import { render, staticRenderFns } from "./IdentificationDocument.vue?vue&type=template&id=56e86271&scoped=true&"
import script from "./IdentificationDocument.vue?vue&type=script&lang=ts&"
export * from "./IdentificationDocument.vue?vue&type=script&lang=ts&"
import style0 from "./IdentificationDocument.vue?vue&type=style&index=0&id=56e86271&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e86271",
  null
  
)

export default component.exports